import React from 'react';
import { observer } from 'mobx-react';

import NavbarHeaderMobile from '../../../Styleguide/NavbarHeaderMobile/NavbarHeaderMobile';

const MainMobileNavBar = () => <NavbarHeaderMobile hasGoBack content='nav' />;
export default observer(MainMobileNavBar);
